/**
 * Short, locale-aware date for UI copy (e.g. "Sep 14, 2026"). Returns null for empty or
 * unparseable input so callers can simply omit the date.
 */
export function formatCompactDate(raw: unknown): string | null {
  if (raw == null || raw === '') return null;
  try {
    const d = new Date(raw as any);
    if (!Number.isFinite(d.getTime())) return null;
    return new Intl.DateTimeFormat(undefined, { year: 'numeric', month: 'short', day: '2-digit' }).format(d);
  } catch (_e) {
    return null;
  }
}
